module.exports = __webpack_public_path__ + "img/2019_l_o_s_b.0c2d1871.jpg";